import https from 'https';
import axios from 'axios';
import helpers from '../utils/helpers';
const base_endpoint = process.env.API_URL;

const headers = {
  'Content-type': 'application/json',
};
const httpsAgent = new https.Agent({
  rejectUnauthorized: false
});

export default function ({ app, $axios, query, store, route }) {
  $axios.defaults.timeout = 30000;
  $axios.onError(error => {
    if (helpers.isNetworkRelatedError(error)) {
      store.commit("notifications/addSnackBar", {
        code: "NETWORK",
      });
    }
  });
  $axios.onResponse(({ data }) => {
    if (!helpers.isEmpty(data.applicationSystem) && data.applicationSystem.code === 10) {
      toast.danger(data.applicationSystem.message);
    }
  });
  $axios.onRequest(config => {
    config.baseURL = base_endpoint;

    let token = query.t;
    token = helpers.isEmpty(token) ? app.$cookies.get('token') : token;

    if (token) {
      let no_need_encode = false;
      try {
        no_need_encode = helpers.parseJwt(token)
        no_need_encode = !helpers.isEmpty(no_need_encode) && !helpers.isEmpty(no_need_encode.username) && !helpers.isEmpty(no_need_encode.appid)
      } catch (e) {
      }

      token = no_need_encode ? token : helpers.encodeToken(token)
      headers['Authorization'] = 'Bearer ' + token;

      if (!helpers.isEmpty(config.headers["x-gmid"])) {
        headers["x-gmid"] = config.headers["x-gmid"];
      }

      if (!helpers.isEmpty(config.headers["x-gid"])) {
        headers["x-gid"] = config.headers["x-gid"];
      }
    }

    config.headers = headers;
    config.httpsAgent = httpsAgent;
  })
}

if (process.browser) {
  global.axios = axios;
}
